import { AttributesClass, LocalizedAttributesValue } from 'src/generated/operations.ts';

function isLocalizedAttribute(arg: unknown): arg is LocalizedAttributesValue {
    return !!arg && typeof arg === 'object' && 'raw' in arg && Array.isArray(arg.raw);
}

export function getRawAttributeValue<T extends AttributesClass>(
    data: T,
    name: keyof T,
    fallback: string = '',
) {
    if (!data[name]) {
        return fallback;
    }
    const attribute = data[name];
    if (isLocalizedAttribute(attribute)) {
        const value = attribute.raw || [];
        return value.join('');
    }
    return fallback;
}
